/* Keoki Shop - barra de compra fija en movil.
   No duplica el formulario: localiza el boton real de la ficha y
   lo pulsa, de modo que toda la logica del tema (variante,
   cantidad, carrito lateral) sigue siendo la del tema. */
(function () {
  if (!document.body.classList.contains('product')) return;

  var realBtn =
    document.querySelector('.product-form__submit') ||
    document.querySelector('button[name="add"]');
  if (!realBtn) return;

  var titleEl = document.querySelector('.product__title h1, .product-title h1, h1');
  var priceEl = document.querySelector('.product__info-wrapper .price, .product-section .price, .price');

  var bar = document.createElement('div');
  bar.className = 'keoki-sticky-cta';
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', 'Compra rapida');

  var info = document.createElement('div');
  info.className = 'keoki-sticky-cta__info';

  var t = document.createElement('span');
  t.className = 'keoki-sticky-cta__title';
  // El titulo lleva la marca detras de una barra; en la barra fija
  // sobra, solo hay sitio para el nombre.
  var rawTitle = titleEl ? titleEl.textContent.trim() : '';
  t.textContent = rawTitle.split('|')[0].trim();

  var p = document.createElement('span');
  p.className = 'keoki-sticky-cta__price';

  // El bloque de precio incluye una etiqueta oculta ("Precio") para
  // lectores de pantalla. Aqui solo interesa la cifra.
  function syncPrice() {
    if (!priceEl) return;
    var txt = priceEl.textContent.replace(/\s+/g, ' ');
    var m = txt.match(/[\d.,]+\s*(?:€|EUR)/);
    p.textContent = m ? m[0].trim() : '';
  }
  syncPrice();

  info.appendChild(t);
  info.appendChild(p);

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'keoki-sticky-cta__btn';

  function syncBtn() {
    var label = (realBtn.textContent || '').replace(/\s+/g, ' ').trim();
    btn.textContent = label || 'Añadir a la cesta';
    btn.disabled = !!realBtn.disabled;
  }
  syncBtn();

  btn.addEventListener('click', function () {
    realBtn.click();
  });

  bar.appendChild(info);
  bar.appendChild(btn);
  document.body.appendChild(bar);

  try {
    new MutationObserver(function () {
      syncBtn();
      syncPrice();
    }).observe(realBtn, { attributes: true, childList: true, subtree: true });
  } catch (e) {}

  var shown = false;
  function toggle(v) {
    if (v === shown) return;
    shown = v;
    bar.classList.toggle('is-visible', v);
    document.body.classList.toggle('keoki-cta-visible', v);
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        var e = entries[0];
        toggle(!e.isIntersecting && e.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    ).observe(realBtn);
  }
})();
